<template>
  <div class="stockCont">
    <div class="infosearch">
      <el-input v-model="serviceName" placeholder="输入商品编号或商品名称搜索"  @keyup.native="specialCharacter" style="width: 250px;margin:0 10px"></el-input>
      <el-button class="searchBtn" @click="enterSeach"></el-button>
      <span class="checkBoxcom">
        <el-checkbox v-model="isBelowSaftyStock" @change="chooseStock">现有库存低于安全库存</el-checkbox>
      </span>
      <el-button class="darkBtn" @click="outportExcel">导出</el-button>
      <el-button type="primary" v-if="menuChildIndex == 2" @click="addEnter(2)">整套服务商品入库</el-button>
      <el-button type="primary" v-if="menuChildIndex == 10" @click="addEnter(10)">零售商品入库</el-button>
    </div>
    <div class="vouExper">
      <div class="vouExper_s1" v-for="(item,index) in vouExperion" :key="index">
        <li @click="operaMenu(item)" :class="menuChildIndex == item.value && 'on'"><a href="javascript:;"><b>{{item.name}}（{{item.vouNumb}}）</b></a></li>
      </div>
    </div>
    <el-table v-if="tableData.length > 0" :data="tableData" height="602" ref="multipleTable" class="myMemTable" style="width: 100%"  :header-cell-style="{background:'#EFF1F5'}">
      <el-table-column align="center" prop="serviceCode" label="商品编号"></el-table-column>
      <el-table-column align="center" prop="serviceName" label="商品名称"></el-table-column>
      <el-table-column align="center" prop="expiryDate" label="最近有效期">
        <template slot-scope="scope">
          <span>{{scope.row.expiryDate | filterRow}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="availableStock" :label="availabN"></el-table-column>
      <span v-if="menuChildIndex == 2">
        <el-table-column align="center" prop="checkInventory" label="寄存库存（套）">
          <template slot-scope="scope">
            {{scope.row.checkInventory | filterRow}}
          </template>
        </el-table-column>
      </span>
      <el-table-column align="center" label="操作" width="260">
        <template slot-scope="scope">
          <el-button size="mini" type="success" v-if="menuChildIndex == 2" @click="comSplit(scope.row)">整套拆分</el-button>
          <el-button size="mini" class="redBtn" @click="adjustStock(scope.row)">调整库存</el-button>
          <el-button size="mini" class="darkBtn" @click="records(scope.row)">出入记录</el-button>
        </template>
      </el-table-column>
    </el-table>
    <template v-else>
      <div class="emptys">查不到库存监控信息！再核对一下试试</div>
    </template>
    <el-pagination v-show="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" background layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px;text-align:right"></el-pagination>
    <el-dialog :title="stSplit?'整套拆分':'调整库存'" :visible.sync="dialogstockVisible" :center="true" width="580px">
      <publicBox :serviceRow='serviceRow' :stSplit="stSplit" @closeDialog='closeDialog'/>
    </el-dialog>
    <el-dialog :title="serviceRow.serviceName+'-库存变动记录'" :visible.sync="dialogRecordVisible" :center="true" top="60px" width="1200px">
      <recordData :serviceRow='serviceRow' :dialogRecordVisible = "dialogRecordVisible" @closeDialog='closeDialog' />
    </el-dialog>
  </div>
</template>
<script>
import publicBox from "./publicBox";
import recordData from "./recordData";
import {queryInventoryAdjustPageList, adjustDetailList, adjustStoreServiceCount} from "@/api";
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  components: {
    publicBox,recordData
  },
  data() {
    return {
      pickerOptions2: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      stockform:{
        choosestockTime:[],
      },
      serviceName: "",
      isBelowSaftyStock: "",
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
      fullscreenLoading: false,
      dialogstockVisible: false,
      serviceRow:'',
      dialogRecordVisible:false,
      rules:{
        choosestockTime:[
          {
            required: true,
            message: "请选择导出时间",
            trigger: "change"
          }
        ]
      },
      vouExperion:[
        {value:1,name:'单次服务商品',vouNumb:0},
        {value:2,name:'整套服务商品',vouNumb:0},
        {value:10,name:'零售服务商品',vouNumb:0},
      ],
      menuChildIndex:1,
      availabN:'现有库存（次）',
      stSplit:false
    };
  },
  created() {
    if(this.$store.state.alivePage == 1 || this.$store.state.alivePage == 2 || this.$store.state.alivePage == 10) {
      this.menuChildIndex =  this.$store.state.alivePage;
    }else{
      this.menuChildIndex = 1;
    }
    this.search();
    this.getPacka();
  },
  activated() {
    if(this.$store.state.alivePage == 1 || this.$store.state.alivePage == 2 || this.$store.state.alivePage == 10) {
      this.menuChildIndex =  this.$store.state.alivePage;
    }else{
      this.menuChildIndex = 1;
    }
    this.search();
    this.getPacka();
  },
  methods: {
    specialCharacter() {
      this.serviceName = this.serviceName.replace(
        /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im,
        ""
      );
    },
    comSplit(row){//拆分
      this.stSplit = true;
      this.dialogstockVisible = true;
      this.serviceRow = row;
    },
    addEnter(val){//添加
      this.$router.push('/businessManagementCenter/substock' + val);
    },
    adjustStock(row) { // 调整库存
      this.stSplit = false;
      this.dialogstockVisible = true;
      this.serviceRow = row;
    },
    getPacka(){
      adjustStoreServiceCount({storeCode:this.$store.state.userInfo.storeCode}).then(res => {
        res.data.forEach(item => {
          for(let i of this.vouExperion){
            if(i.value == item.type){
              i.vouNumb = item.count;
            }
          }
        });
      })
    },
    operaMenu(val){ //tab卷
      this.currentPage = 1;
      this.menuChildIndex = val.value;
      this.$store.commit('setAlivePage',this.menuChildIndex)
      this.search();
      if(this.menuChildIndex == 1){
        this.availabN = '现有库存（次）'
      }else if(this.menuChildIndex == 2){
        this.availabN = '现有库存（套）'
      }else{
        this.availabN = '现有库存（件）'
      }
    },
    search(val) {
      this.fullscreenLoading = true;
      let postData = {
        isBelowSaftyStock:this.isBelowSaftyStock?'1':'',
        serviceName:this.serviceName,
        serviceType:this.menuChildIndex,
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        storeCode:this.$store.state.userInfo.storeCode
      }
      queryInventoryAdjustPageList(postData).then(res =>{
        this.fullscreenLoading = false;
        if (res.code == 1) {
          this.total = res.data.total;
          this.tableData = res.data.rows;
        }
      });
    },
    enterSeach() {
      this.currentPage = 1;
      this.search();
      this.getPacka();
    },
    chooseStock() { // 现有库存低于安全库存
      this.search();
    },
    closeDialog(val){
      this.dialogRecordVisible = val;
      this.dialogstockVisible = val;
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    records(row) {//库存变动记录
      this.dialogRecordVisible = true;
      this.serviceRow = row;
    },
    outportExcel(){// 导出
      let postData = {
        isBelowSaftyStock:this.isBelowSaftyStock?'1':'',
        serviceName:this.serviceName,
        serviceType:this.menuChildIndex,
		    storeCode:this.$store.state.userInfo.storeCode
      }
      this.$http.post(adjustDetailList, postData, {
        headers:{
          userId:this.$store.state.userInfo.redisKey
        },
        responseType: "blob"
      })
      .then(res => {
        if(res.data.type == "application/json"){
          this.$message({
            message: '无库存监控信息！',
            type: 'error'
          });
          this.openFlag = false;
          return
        }
        const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
        const fileName = '库存监控管理明细.xls';
        if ('download' in document.createElement('a')) {
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        }else{
          navigator.msSaveBlob(blob, fileName);
        }
        this.$nextTick(()=>{
          this.openFlag = false;
        })
      })
    }
  }
};
</script>
<style lang="less" scoped>
.stockCont {
  padding: 25px 0;
  .infosearch {
    .el-input__inner {
      border-radius: 20px;
    }
    .searchBtn {
      width: 47px;
      height: 38px;
      background: #f83b56 url(../../assets/images/store/btn_datalist_search.png)
        no-repeat center;
    }
    .addMems {
      color: #fff;
      font-weight: bold;
      text-indent: 20px;
      background: #3b404f url(../../assets/images/store/btn_datalist_add.png)
        no-repeat 15px center;
    }
    .checkBoxcom {
      margin: 0 40px 0 50px;
    }
  }
  .myMemTable {
    border: 1px solid #d5d9e3;
    .tableGoods {
      .myTitle {
        width: 100%;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .el-button--mini {
      padding: 8px;
      font-weight: bold;
    }
  }
  .emptys {
    height: 600px;
    background: url(../../assets/images/store/img_vip_none.png) no-repeat center;
    text-align: center;
    font-size: 15px;
    color: #666;
    padding-top: 450px;
  }
}
.warning {
    padding: 0 0 0 20px;
    font-size: 13px;
    line-height: 28px;
    .redFont{
        color: #F83B56;
    }
}
.redTips{
  color: #F83B56;
  background: url(../../assets/images/store/tips.png) no-repeat right center;
  padding-right: 25px;
  cursor: pointer;
}
</style>
<style lang="less">
.stockCont {
  .el-dialog__title {
    font-weight: bold;
  }
  .dialogbtnOptions {
    margin-top: 26px;
    text-align: center;
    .el-button {
      min-width: 105px;
      height: 38px;
      border: none;
    }
  }
}
.myMemTable {
  .el-table__header {
    background: rgb(239, 241, 245);
  }
  .highLight {
    background: #eff1f5;
  }
  .redLight{
    background: #fedee3!important;
  }
}
</style>
<style lang="less">
.stockTime{
  margin:-10px 0 0 0;
  .el-date-editor .el-range-separator {
    width: 26px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/stock.vue